<form id="gift-received-form" *ngIf="form && importGiftFields" [formGroup]="form"
  [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g">
    <div class="ui-g-9 ui-md-9 ui-lg-9">
      <h1 class="step-title">{{ 'reservations.newImport' | translate }}</h1>
    </div>
    <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left"
        routerLink="/loyalty/import-gift" label="{{ 'common.back' | translate }}"></button>
      <button pButton class="k-generic-btn" (click)="controlFile()" type="button" icon="fa fa-floppy-o" iconPos="left"
        label="{{'movement.run_import' | translate}}" [disabled]="!this.giftFile"></button>
    </div>
  </div>

  <div class="card">
    <div class="ui-g ui-fluid">

      <!-- Descrizione -->
      <div class="ui-g-12 ui-md-12">
        <span class="label" [ngClass]="{'required': !importGiftFields.description.nullable}">{{
          importGiftFields.description.keyName }}</span>
        <p-editor type="html" class="fieldInput" formControlName="description" ></p-editor>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
          [validation]="importGiftFields.description"></app-validation-msg>
      </div>

    </div>

    <br>

    <!-- Carica File-->
    <!-- <div class="ui-g ui-fluid">
      <div class="ui-g-6 ">
        <span class="label padd-label">{{ 'reservations.importFile' | translate }}</span>
        <p-fileUpload #fileUploadRef data-testid="fileUploadRef" name="importFile" customUpload="true" multiple="true" auto="true"
          (uploadHandler)="onMovementFileUpload($event)" required="true" accept=".xls,.xlsx"></p-fileUpload>
      </div>
      <div class="ui-g-6 ">
        <span class="label padd-label">{{ 'reservations.importFile' | translate }}</span>
        <p-fileUpload #fileUploadRef data-testid="fileUploadRef" name="importFile" customUpload="true" multiple="true" auto="true"
          (uploadHandler)="onMovementFileUpload($event)" required="true" accept=".xls,.xlsx"></p-fileUpload>
      </div>
    </div> -->

    <!-- Nuovo Import Catalogo Premi-->
    <div class="ui-g ui-fluid">
      <!-- Catalogo Premi xls-->
      <div class="ui-g-6 ">
        <div class="label-import">
          <label>{{ 'reservations.importFile' | translate }}</label>
        </div>
        <p-fileUpload #fileUploadRef data-testid="fileUploadRef" name="catalog" multiple="false" customUpload="true" auto="true"
        (uploadHandler)="onMovementFileUpload($event)" required="true" accept=".xls,.xlsx"  [disabled]="this.giftFile">
        <ng-template pTemplate="content">
          <div *ngIf="!this.giftFile" class="ui-fluid drag">
            <i class="fa fa-upload icon-upload"></i>
            <br>
            <strong class="drag-description">Drag & Drop File</strong>
          </div>
        </ng-template>
          <ng-template let-file pTemplate="catalog">
              <div class="ui-fileupload-row file-row ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-2"> <i class="fa fa-file-o file-icon"></i> </div>
                    <div class="ui-g-8">
                      <strong>{{file.name}}</strong><br>
                      <div class="file-size">{{getSizeInMegaBytes(file) | number:'1.2-2'}} MB</div>
                    </div>
                    <div class="ui-g-2">
                      <span class="delete-btn" pTooltip="{{'common.delete' | translate}}" tooltipPosition="right">
                        <i class="fa fa-trash-o" (click)="removeFile(file, fileUploadRef)"></i>
                      </span>
                  </div>
                  </div>
              </div>
            </ng-template>
        </p-fileUpload>
      </div>

      <!-- Immagini Catalogo-->
      <div class="ui-g-6 ">
        <div class="label-import">
          <label>{{ 'reservations.importImage' | translate }}</label>
        </div>
        <p-fileUpload #createUploader data-testid="createUploader" name="image" multiple="multiple" customUpload="true" auto="true"
        (uploadHandler)="imageFileUpload($event)" required="true" accept=".zip">
        <ng-template pTemplate="content">
          <div *ngIf="this.imageFile.length == 0" class="ui-fluid drag">
            <i class="fa fa-upload icon-upload"></i>
            <br>
            <strong class="drag-description">Drag & Drop File</strong>
            <!-- <br>
            <strong class="drag-description">or</strong>
            <br><br>
            <label class="custom-file-upload">
              <input type="file" accept=".png, .jpeg, application/zip" (change)="handleImageInput($event.target.files)" multiple/>
              Choose File
          </label> -->
          </div>
        </ng-template>
          <ng-template let-image pTemplate="image">
              <div class="ui-fileupload-row file-row ui-g-12">
                  <div class="ui-g-12">
                    <div class="ui-g-2"> <i class="fa fa-file-o file-icon"></i> </div>
                    <div class="ui-g-8 padd">
                      <strong>{{image.name}}</strong><br>
                      <div class="file-size">{{getSizeInMegaBytes(image) | number:'1.2-2'}} MB</div>
                    </div>
                    <div class="ui-g-2">
                      <span class="delete-btn" pTooltip="{{'common.delete' | translate}}" tooltipPosition="right">
                        <i class="fa fa-trash-o" (click)="removeFileImage(image, createUploader)"></i>
                      </span>
                    </div>
                  </div>
              </div>
            </ng-template>
        </p-fileUpload>
      </div>
    </div>

  </div>

</form>

<p-dialog
        *ngIf="imagesNotPresent"
        [(visible)]="imagesNotPresent"
        [modal]="true"
        header="{{'reservations.imagesNotPresentModal' | translate}}"
        [width]="400"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
    <div class="ui-g-12">
      <span>{{'reservations.importImagesNotPresent' | translate}}</span>
    </div>
    <div class="ui-g-12 text-align-center">
      <button pButton class="k-generic-btn" (click)="import()" type="button" icon="fa fa-floppy-o" iconPos="left"
      label="{{'movement.run_import' | translate}}"></button>
    </div>

  </p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-import-gift/loyalty-import-gift-detail/loyalty-import-gift-detail.component.html